/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AggiornamentoRicarica } from './aggiornamentoRicarica';

export interface Ricarica { 
    id?: string;
    annoDiRiferimento?: string;
    data?: Date;
    dataPagamento?: string;
    metodoPagamento?: string;
    numeroBollettino?: string;
    valore?: number;
    operatore?: string;
    note?: string;
    slugComune?: string;
    identificativoUnivocoVersamento?: string;
    identificativoUnivocoDovuto?: string;
    numeroAvviso?: string;
    idFlusso?: string;
    qrCode?: string;
    stato?: string;
    statoInterno?: Ricarica.StatoInternoEnum;
    pagamentoDaVerificare?: boolean;
    verificaInRitardo?: boolean;
    aggiornamenti?: Array<AggiornamentoRicarica>;
    ricaricaCancellabile?: boolean;
    created_at?: Date;
    updated_at?: Date;
}
export namespace Ricarica {
    export type StatoInternoEnum = 'GENERAZIONE_IN_CORSO' | 'IN_ATTESA_PAGAMENTO' | 'PAGATA' | 'ERRORE' | 'CANCELLATA';
    export const StatoInternoEnum = {
        GENERAZIONEINCORSO: 'GENERAZIONE_IN_CORSO' as StatoInternoEnum,
        INATTESAPAGAMENTO: 'IN_ATTESA_PAGAMENTO' as StatoInternoEnum,
        PAGATA: 'PAGATA' as StatoInternoEnum,
        ERRORE: 'ERRORE' as StatoInternoEnum,
        CANCELLATA: 'CANCELLATA' as StatoInternoEnum
    };
}